import { render, staticRenderFns } from "./MenuFormModal.vue?vue&type=template&id=c854dfa6"
import script from "./MenuFormModal.vue?vue&type=script&lang=js"
export * from "./MenuFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports